import * as React from 'react';
import { useState } from 'react';
import MobileCard from 'src/components/mobile/MobileCard';
import SimpleTable from 'src/components/common/SimpleTable/SimpleTable';
import classNames from 'classnames';
import styles from '../../../assets/case-component-tab.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import ColumnForm from './ColumnForm';
import DeleteAdminWorkAction from './DeleteAdminWorkAction';

import { Paginated } from 'src/services/api-handlers/pagination';

import { getValFromEnum } from 'src/components/redux-form/utils/dropdown-values';

import ModalComponent from 'src/components/modals/ModalComponent';

import { changeToZeroMoment } from 'src/helpers/timeHelpers';

import { IProvider } from 'src/types/provider';
import { IAdminWork } from 'src/types/adminWork';
import GeneralEnumService from 'src/enumerables/general-enum';
import { numberWithCommas } from '../../../../../../../../../helpers/format';

export interface StateProps {}
export interface DispatchProps {}

export interface OwnProps {
    provider: Partial<IProvider> | null;
    data: Paginated<IAdminWork>;
    month: { monthEnd: string; monthStart: string };
    getData: any;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const AdminWorkTable: React.FunctionComponent<Props> = ({ month, data, provider, getData }: Props) => {
    const [opened, setOpened] = useState(-5);
    const [formColumn, setFormColumn] = useState<any>(false);
    const [popup, setPopup] = useState<boolean>(false);
    const [openDrop, setOpenDrop] = useState<boolean>(false);

    const [currentAction] = useState<string>('SIGN');

    const dataSessionComponents: any = [];

    const entityModal: any = {};
    const { totalPages, page } = data;
    let totalFull = 0;
    let totalHours = 0;
    //const totalRate = 0;

    const isMobile = window.innerWidth <= 800;

    data.list.forEach((itSes: any) => {
        totalHours += itSes.totalHours ? +itSes.totalHours : 0;
        //  totalRate += itSes.adminRate ? +itSes.adminRate : 0;
        totalFull += itSes.totalAmount ? +itSes.totalAmount : 0;
        if (`${formColumn}` === `${itSes['id']}`) {
            dataSessionComponents.push({
                ColumnForm: ColumnForm,
                setOpenDrop,
                getData,
                month,
                providerId: provider?.id,
                ...itSes,
            });
            return false;
        }

        const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('AdminWorkStatus') : {};
        const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
        let valueStatus: any = statusItems.find((it) => it.value === itSes.status);
        valueStatus = valueStatus ? valueStatus.label : '';
        dataSessionComponents.push({
            ...itSes,

            action: (
                <div style={{ display: 'flex' }}>
                    {itSes.status !== 4 ? (
                        <div>
                            <button
                                className={classNames(styles.editBtn, 'btn btn-info')}
                                type={'button'}
                                onClick={() => setFormColumn(itSes['id'])}
                            >
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </button>
                            <DeleteAdminWorkAction data={{ id: itSes.id }} />
                        </div>
                    ) : null}
                </div>
            ),
            status: <div style={{ minWidth: 150, maxWidth: 150 }}>{valueStatus}</div>,

            adminWorkDate: itSes.adminWorkDate ? changeToZeroMoment(itSes['adminWorkDate'], 'MMM D, YYYY') : '',
            startTime: itSes.startTime ? changeToZeroMoment(itSes['startTime'], 'LT') : '',
            endTime: itSes.endTime ? changeToZeroMoment(itSes['endTime'], 'LT') : '',
            adminRate: itSes.adminRate ? `$${numberWithCommas(itSes.adminRate)}` : '$0.00',
            totalAmount: itSes.totalAmount ? `$${numberWithCommas(itSes.totalAmount)}` : '',
        });
    });

    if (formColumn === true) {
        if (isMobile) {
            dataSessionComponents.unshift({
                ColumnForm: ColumnForm,
                month,
                getData,
                providerId: provider?.id,
                setOpenDrop,
            });
        } else {
            dataSessionComponents.push({
                ColumnForm: ColumnForm,
                month,
                getData,
                providerId: provider?.id,
                setOpenDrop,
            });
        }
    } else {
        if (data.list.length) {
            dataSessionComponents.push({
                totalColumn: true,
                totalHours: totalHours ? totalHours.toFixed(2) : 0,
                //    adminRate: `$${totalRate}`,
                totalAmount: `$${numberWithCommas(totalFull)}`,
            });
        }
    }

    return (
        <div className={'d-flex flex-column'}>
            <div
                style={openDrop ? { overflow: 'visible' } : {}}
                className={classNames(styles.Table, 'responsive-table')}
            >
                {isMobile ? (
                    <MobileCard
                        type={'adminWork'}
                        action={(val) => {
                            setFormColumn(val);
                            if (!val) {
                                setOpened(-5);
                            }
                        }}
                        opened={opened}
                        setOpened={setOpened}
                        columns={[
                            { id: 'action', label: 'Action', cellStyle: 'normal' },
                            { id: 'adminWorkDate', label: 'Date', cellStyle: 'normal' },
                            { id: 'startTime', label: 'Start Time', cellStyle: 'normal' },
                            { id: 'endTime', label: 'End Time', cellStyle: 'normal' },
                            { id: 'totalHours', label: 'Total Hours', cellStyle: 'normal' },
                            { id: 'adminRate', label: 'Admin Rate per Hour', cellStyle: 'normal' },
                            { id: 'totalAmount', label: 'Amount $', cellStyle: 'normal' },
                            { id: 'description', label: 'Comment', cellStyle: 'normal' },
                            { id: 'status', label: 'Status', cellStyle: 'normal' },
                        ]}
                        pagination={{ page, totalPages }}
                        data={dataSessionComponents}
                    />
                ) : (
                    <SimpleTable
                        action={setFormColumn}
                        data={dataSessionComponents}
                        pagination={{ page, totalPages }}
                        columns={[
                            { id: 'action', label: 'Action', cellStyle: 'normal' },
                            { id: 'adminWorkDate', label: 'Date', cellStyle: 'normal' },

                            { id: 'startTime', label: 'Start Time', cellStyle: 'normal' },
                            { id: 'endTime', label: 'End Time', cellStyle: 'normal' },
                            { id: 'totalHours', label: 'Total Hours', cellStyle: 'normal' },
                            { id: 'adminRate', label: 'Admin Rate per Hour', cellStyle: 'normal' },
                            { id: 'totalAmount', label: 'Amount $', cellStyle: 'normal' },
                            { id: 'description', label: 'Comment', cellStyle: 'maxWidth' },
                            { id: 'status', label: 'Status', cellStyle: 'normal' },
                        ]}
                    />
                )}

                <ModalComponent
                    modal={popup}
                    setModal={setPopup}
                    dataBody={entityModal[currentAction]?.body}
                    action={entityModal[currentAction]?.action}
                />

                <div className={'d-flex justify-content-end'}>
                    <button
                        className={'btn mr-1 ml-1 mb-2 btn-outline-info'}
                        type={'button'}
                        onClick={() => {
                            setOpened(0);
                            setFormColumn(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faPlusCircle} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminWorkTable;
